import React /*, { Component }*/ from "react";
// import AuthApp from "widgets/mu-authorization/WidgetInterface";
import reqConf from "./klimaRequestConfig"; // "configs/TestConfigsBKO/Requests/ReqGesamtConfig";
// import bttRootGrid from "configs/TestConfigsBKO/Grids/BTTRootGrid";
// import MultiGrid from "widgets/grid/MultiGrid";
// import TestApp from "widgets/test/Widget";
// import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
// import EditToolbar from "widgets/Editor/src/EditToolbar";
// import Editornls from "widgets/Editor/src/nls/strings";
// import Controller from "widgets/Editor/src/Controller";
// import filterConfig from "configs/filterConfig";
// import Filter from "widgets/Filter/Filter";
//Selection
// import SelectionWidget from "widgets/Selection/src/components/WidgetComponent";
// import selectionnls from "widgets/Selection/src/nls/strings";
// import LayerOverview from "widgets/LayerOverview/src/components/WidgetComponent";
// import LayerOverviewNls from "widgets/LayerOverview/src/nls/strings";
// import layerStore from "@giscon/utils.layer-store";
// import nls from "widgets/Editor/src/nls/strings";
import MapFilter from "../widgets/MapFilter";
import { wmsProxyUrl } from "./config";
import KlimaSliderWrapper from "components/KlimaSliderWrapper";
import PossibilityUpdater from "components/PossibilityUpdater";
import OverrideUpdater from "components/OverrideUpdater";
import RasterStatistics from "../widgets/rasterStatistics/RasterStatistics";
import Identify from "../widgets/identify";
import MapBusyIndicator from "components/MapBusyIndicator";
import OverviewMap from "../widgets/OverviewMap";
import CallMadeIcon from "@mui/icons-material/CallMade";
import ForecastToggle from "components/ForecastToggle";
import URLParameterController from "components/URLParameterController";
import Introduction from "../widgets/Introduction";

const widgets = {
  mapFilter: {
    Widget: MapFilter,
    isClassComp: true,
    props: {
      WMSProxy: wmsProxyUrl,
    },
    icon: ({ open }) => (
      <SendIcon
        style={{
          transform: open
            ? "matrix(-1, 0, 0, 1, 0, 0)"
            : "matrix(1, 0, 0, 1, 0, 0)",
          transition: "transform 0.5s ease",
        }}
      ></SendIcon>
    ),
  },
  mapBusy: {
    Widget: MapBusyIndicator,
  },
  overviewMap: {
    Widget: OverviewMap,
    icon: ({ open }) => (
      <CallMadeIcon
        style={{
          transform: open
            ? "matrix(1, 0, 0, -1, 0, 0)"
            : "matrix(-1, 0, 0, 1, 0, 0)",
          transition: "transform 0.5s ease",
        }}
      ></CallMadeIcon>
    ),
  },
  KlimaSliderWrapper: {
    Widget: KlimaSliderWrapper,
    props: {
      attributeId: "Zeitraum",
    },
  },
  PossibilityUpdater: {
    Widget: PossibilityUpdater,
    props: {
      attributeId: "Zeitraum",
    },
  },
  SzenarioPossibilityUpdater: {
    Widget: PossibilityUpdater,
    props: {
      attributeId: "Szenario",
    },
  },
  OverrideUpdater: {
    Widget: OverrideUpdater,
    props: {},
  },
  URLParameterController: {
    Widget: URLParameterController,
    props: {
      HistoryLimit: 5,
      // attributeId: "Zeitraum",
    },
  },
  Introduction: {
    Widget: Introduction,
    props: {},
  },
  Forecast: {
    Widget: ForecastToggle,
    props: {
      attributeId: "Characteristic",
    },
  },
  stats: {
    Widget: RasterStatistics,
    icon: ({ open }) => (
      <SendIcon
        style={{
          transform: open
            ? "matrix(1, 0, 0, 1, 0, 0)"
            : "matrix(-1, 0, 0, 1, 0, 0)",
          transition: "transform 0.5s ease",
        }}
      ></SendIcon>
    ),
    props: {
      style: { padding: 20 },
      decimalPlaces: 2,
      infoTextAttributeId: "Parameter",
    },
  },
  identify: {
    Widget: Identify,
    icon: ({ open }) => (
      <SendIcon
        style={{
          transform: open
            ? "matrix(1, 0, 0, 1, 0, 0)"
            : "matrix(-1, 0, 0, 1, 0, 0)",
          transition: "transform 0.5s ease",
        }}
      ></SendIcon>
    ),
    props: {
      style: { padding: 20 },
      decimalPlaces: 2,
    },
  },
};

const widgetConfigs = {
  widgets: widgets,
  requestsConfig: reqConf,
  updateConfigsKey: "config",
  tokenId: "token",
  leftOptions: {
    width: "360",
    minWidth: "360",
    initActive: "mapFilter",
  },
  rightOptions: {
    width: "360",
    initActive: "stats",
  },
  right: ["stats"],
  left: ["mapFilter"],
  overlay: [
    "PossibilityUpdater",
    "SzenarioPossibilityUpdater",
    "OverrideUpdater",
    "URLParameterController",
    "Introduction",
    "KlimaSliderWrapper",
    "mapBusy",
  ],
  onMap: [
    {
      positionOptions: {
        right: 20,
        bottom: 150,
        minHeight: 300,
        maxHeight: 1000,
        minWidth: 400,
        maxWidth: 1000,
        closeable: true,
        relativeToMap: true,
        moveable: false,
        resizeDirections: [
          // "bottom-right",
          // "bottom-left",
          "top-left",
          // "top-right",
          // "right",
          // "bottom",
        ],
      },
      buttonPosition: "bottom right",
      order: ["overviewMap"],
    },
    // {
    //   positionOptions: {
    //     right: 50,
    //     minHeight: 350,
    //     closeable: false,
    //     moveable: false,
    //     relativeToMap: true,
    //     initActive: "Forecast",
    //   },
    //   order: ["Forecast"],
    // },
  ],
};

export default widgetConfigs;
